var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('echarts',{staticStyle:{"width":"100%","height":"350px"},attrs:{"options":_vm.echartsData,"auto-resize":true}}),_c('Table',{attrs:{"data":_vm.data,"columns":_vm.columns,"border":"","loading":_vm.loading}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7eb8d194","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/dialysisStatistics/parts/year.vue
// module id = null
// module chunks = 